import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { all, put, takeLatest, delay, takeEvery } from "redux-saga/effects";
import history from '../../providers/history';
import { itemsNamesListRequestService, itemsNamesSaveRequestService, itemsNamesRemoveRequestService } from "./services";
import { itemsNamesListFailure, itemsNamesListRequest, itemsNamesListSuccess, itemsNamesSetPagination, itemsNamesSaveSuccess, itemsNamesSaveFailure, itemsNamesSaveRequest, itemNameRemoveSuccess, itemNameRemoveFailure, itemNameRemoveRequest, stopEditingItemName } from "./slice";
import { IItemNameFilter, IItemsNamesResponse, IItemName, IItemNameSaveRequestPayload, IItemNameSaveRequestResponse, IItemNameRemoveRequestResponse } from "./types";


// LIST ITEMS NAMES
function* itemsNamesListRequestSaga(action: PayloadAction<IItemNameFilter | undefined>) {
    try {
        const itemsNamesListResponse: AxiosResponse<IItemsNamesResponse> = yield itemsNamesListRequestService(action.payload);

        if (itemsNamesListResponse.data.status) {
            yield put(itemsNamesListSuccess(itemsNamesListResponse.data.data))
            yield put(itemsNamesSetPagination({
                count: itemsNamesListResponse.data.count,
                countFiltered: itemsNamesListResponse.data.countFiltered
            }))
        }
        else {
            yield put(itemsNamesListFailure({
                message: itemsNamesListResponse.data.message || 'Error trying to get name list'
            }));
        }
    }
    catch (error: any) {
        yield put(itemsNamesListFailure({
            message: error.response.data.message || 'Error trying to get users list'
        }));
    }
}

function* watchItemsNamesListRequestSaga() {
    yield takeLatest(itemsNamesListRequest.type, itemsNamesListRequestSaga);
}

// SAVE ITEM NAME
function* itemNameSaveRequestSaga(action: PayloadAction<IItemName>) {
    try {
        const payloadItemName: IItemNameSaveRequestPayload = {
            name: action.payload.name
        }

        const itemsNamesSaveResponse: AxiosResponse<IItemNameSaveRequestResponse> = yield itemsNamesSaveRequestService(payloadItemName, action.payload.id);

        if (itemsNamesSaveResponse.data.status) {
            yield put(itemsNamesSaveSuccess({
                ...action.payload,

                name: itemsNamesSaveResponse.data.data.name,
                id: itemsNamesSaveResponse.data.data.id
            }))

            yield put(stopEditingItemName())
            history.back();
            yield delay(50);

        }
        else {
            yield put(itemsNamesSaveFailure({
                id: action.payload.id || "",
                error: {
                    message: itemsNamesSaveResponse.data.message || 'Error trying to save Item Name'
                }
            }));
        }
    }
    catch (error: any) {
        yield put(itemsNamesSaveFailure({
            id: action.payload.id || "",
            error: {
                message: error.response.data.message || 'Error trying to get the list of items names'
            }
        }));
    }
}

function* watchItemNameRequestSaga() {
    yield takeLatest(itemsNamesSaveRequest.type, itemNameSaveRequestSaga);
}

// REMOVE ITEM NAME
function* itemsNamesRemoveSaga(action: PayloadAction<string>) {
    try {
        const itemNameRemoveResponse: AxiosResponse<IItemNameRemoveRequestResponse> = yield itemsNamesRemoveRequestService(action.payload);

        if (itemNameRemoveResponse.data.status) {
            history.back();

            yield put(itemNameRemoveSuccess(action.payload))
        }
        else {
            yield put(itemNameRemoveFailure({
                itemNameId: action.payload,
                error: {
                    message: itemNameRemoveResponse.data.message || 'Error trying to remove this item name'
                }
            }));
        }
    } catch (error: any) {
        yield put(itemNameRemoveFailure({
            itemNameId: action.payload,
            error: {
                message: error.response.data.message || 'Error trying to remove this item name'
            }
        }));
    }
}

function* watchItemsNamesRemoveSaga() {
    yield takeEvery(itemNameRemoveRequest.type, itemsNamesRemoveSaga);
}


export default all([
    watchItemsNamesListRequestSaga(),
    watchItemNameRequestSaga(),
    watchItemsNamesRemoveSaga()
])